import { sanitizeNext } from "@bw/shared/sanitize-next";
import { Navigate, useSearchParams } from "react-router-dom";

/**
 * Preserve the shared API client's expired-session destination while keeping
 * `/sign-in?next=…` as Business's one canonical owner-login contract.
 */
export function LegacyLoginRedirect() {
  const [searchParams] = useSearchParams();
  const returnUrl = sanitizeNext(searchParams.get("returnUrl"));
  const target = returnUrl
    ? `/sign-in?next=${encodeURIComponent(returnUrl)}`
    : "/sign-in";

  return <Navigate to={target} replace />;
}
